import { IUpdateHospitalAction, IUpdateHospitalParams } from './updateHospital.interface';
import { UpdateHospitalTypes } from './updateHospital.type';

export const updateHospital = (payload: IUpdateHospitalParams): IUpdateHospitalAction => ({
	type: UpdateHospitalTypes.UPDATE_HOSPITAL,
	payload,
});
